<router-outlet (activate)="topToWindow()">
  <ngx-spinner
    bdOpacity="0.9"
    size="medium"
    color="#01444b"
    type="ball-clip-rotate"
    [fullScreen]="true"
  >
    <p class="loadingText fs-16-vw" style="color: #fff">Loading...</p>
  </ngx-spinner>
</router-outlet>

<ngx-spinner
  name="lazy-route-spinner"
  bdOpacity="0.45"
  size="medium"
  color="#01444b"
  type="ball-clip-rotate"
  [fullScreen]="true"
>
  <p class="loadingText fs-16-vw" style="color: #fff">Loading...</p>
</ngx-spinner>
